import React from 'react';
import styled from 'styled-components';
import {Icon} from '@blueprintjs/core';
import {colors, media} from '../modules/styles';

const WEBINAR_URL = 'https://share.hsforms.com/2734KkHhCQUGhdHH3_Wq3nQd2lol';

export default function MaintenanceBanner() {
  return (
    <Comp role="status">
      <Icon icon="warning-sign" />
      <span>
        Compliance Works will be unavailable the weekend of October 10-12, 2026 as we prepare for the launch of our new application.{' '}
        <a href={WEBINAR_URL} target="_blank" rel="noopener noreferrer">
          Join our upcoming webinar
        </a>{' '}
        to learn more.
      </span>
    </Comp>
  );
}

const Comp = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
  margin: 60px 0 0 0; // Top accounts for header height
  padding: 8px 15px;
  background-color: ${colors.yellowCalloutLight};
  border-bottom: 1px solid ${colors.secondary};
  color: ${colors.black};
  font-weight: 600;
  font-size: 0.8rem;
  text-align: center;

  .bp3-icon {
    flex-shrink: 0;
    margin: 0 10px 0 0;
    color: ${colors.yellowCallout};
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  @media (min-width: ${media.sm}) {
    font-size: 1rem;
  }

  // This banner now sits directly below the fixed header, so anything after it
  // (FreeTrialHeader, Main) no longer needs its own header offset
  && ~ * {
    margin-top: 0;
  }
`;
